<template>
    <ReportsWrapper :report="report" data-test-id="call-reports-extensions">
        <div>
            <LogarithmicSwitcher
                v-model="logarithmic"
                class="ml-5"
            />
            <ExtensionChart
                :items="prepare_items({...report.items})"
                :extensions="report.extensions"
                :logarithmic="logarithmic"
                :formatters="report.formatters"
                :fields="report.fields"
                :key="`logarithmic-${logarithmic}-chart`"
            />
            <ExtensionsTable
                :items="prepare_items({...report.items})"
                :extensions="report.extensions"
                :logarithmic="logarithmic"
                :formatters="report.formatters"
                :fields="report.fields"
                :key="`logarithmic-${logarithmic}-table`"
            />
        </div>
    </ReportsWrapper>
</template>

<script>
  import { vueComponent } from '../../../../libs/helpers2';
  import PerExtension from '../../../../models/PerExtension';
  import ReportsWrapper from '../elements/ReportWrapper.vue';
  import ExtensionsTable from '../elements/tables/Extensions.vue';
  import ExtensionChart from '../elements/charts/PerExtension.vue';
  import LogarithmicSwitcher from '../../../elements/logarithmic-representation-switcher.vue';

  export default {
    components: {
        ReportsWrapper,
        ExtensionsTable,
        ExtensionChart,
        LogarithmicSwitcher,
    },
    data() {
        return {
            logarithmic: false,
            items: null,
            report: new PerExtension(this.$session, vueComponent(this)),
      };
    },
    async created() {
        await this.$data.report.loadItems();
    },
    methods: {
        prepare_items(items) {
        if (!items) return {};

        const transformed = {};
        for (const key of Object.keys(items)) {
          transformed[key] = items[key].map((item) => {
            const val = item.value || 0;
            let displayValue = item.value || 0;
            if (this.$data.logarithmic) {
              displayValue = val > 0 ? Math.log(val) / Math.log(2) : 0;
            }

            return {
              ...item,
              display_value: displayValue
            };
          });
        }
        return transformed;
      }
    }
  };
</script>
